export const transitions = {
  JOIN_WAITLIST: 'transition/join-waitlist',
};

export const states = {
  INITIAL: 'initial',
  WAITLISTED: 'waitlisted',
};

export const graph = {
  id: 'waitlist-process/release-1',
  initial: states.INITIAL,
  states: {
    [states.INITIAL]: {
      on: {
        [transitions.JOIN_WAITLIST]: states.WAITLISTED,
      },
    },
    [states.WAITLISTED]: { type: 'final' },
  },
};

export const isRelevantPastTransition = (transition) => {
  return [transitions.JOIN_WAITLIST].includes(transition);
};

export const isCompleted = (transition) => {
  return [transitions.JOIN_WAITLIST].includes(transition);
};

export const WAITLISTED = 'waitlisted';

export const PROCESS_NAME = 'waitlist-process';
export const PROCESS_ALIAS = `${PROCESS_NAME}/release-1`;
export const UNIT_TYPE = 'entry';

export const isCustomerReview = () => {
  return false;
};

export const isProviderReview = () => {
  return false;
};

export const isPrivileged = () => {
  return false;
};

export const isRefunded = () => {
  return false;
};

export const statesNeedingProviderAttention = [];
